export default "__VITE_ASSET__BHMWH_ze__"